<template>
  <div class="about">
    <Carousel :list="config.banner.about"/>
    <Sections>
      <Title class="animation" anniset="animated fadeInDown" title="公司简介" description="规模大、实力强、品质保障、技术先进、储量丰富"/>
      <div class="intro animation" anniset="animated fadeInUp">
        <div class="bigbox">
           <div class="logo">
             <div>
                <p><img src="/img/logoAbout.png" alt=""></p>
                <!-- <p>{{config.name}}</p> -->
             </div>
           </div>
           <p v-html="config.introduceByAbout">
           </p>
        </div>
      </div>
    </Sections>
    <Sections class="idea">
      <Title  class="animation" anniset="animated fadeInDown" title="公司理念" description="规模大、实力强、品质保障、技术先进、储量丰富"/>
      <ul class="animation" anniset="animated fadeInUp">
        <li v-for="(item,index) in config.companyIdea" :key="index">
          <div class="img">
            <img :src="item.img" alt="">
          </div>
          <p>{{item.txt}}</p>
        </li>
      </ul>
    </Sections>
    <Sections class="culture">
      <Title  class="animation" anniset="animated fadeInDown" title="企业文化" description="规模大、实力强、品质保障、技术先进、储量丰富"/>
      <div class="content animation" anniset="animated fadeInUp" v-html="config.companyCulture"></div>  
    </Sections>
    <!-- <Sections>
      <Title title="发展历史" description="规模大、实力强、品质保障、技术先进、储量丰富"/>
      <Timeline/>
    </!--> 
  </div>
</template>
<script>
import Carousel from '@/components/Carousel'
import Timeline from '@/components/Timeline'
import Title from '@/components/Title'
import Sections from '@/components/Sections'
export default {
  components: {
    Carousel,Timeline,Title,Sections
  },
  mounted(){
    let documentClientHeight = document.documentElement.clientHeight || window.innerHeight;
    let containers = $('body').find('.animation');
    window.addEventListener("scroll",function(e){
    $.each(containers, function (index, item) {
        var top = item.getBoundingClientRect().top;
        if (documentClientHeight >= top) {
            $(item).addClass($(item).attr('anniset'));
        }
    });
    });
    $.each(containers, function (index, item) {
        let  top = item.getBoundingClientRect().top;
        if (documentClientHeight >= top) {
        $(item).addClass($(item).attr('anniset'));
        }
    });
  },
  data(){
    return{
      config
    }
  }
}
</script>

<style lang="less" scoped>
    .intro{
      position: relative;
      width: 90vw;
      height: 30vw;
      box-shadow:  0 0 10px #999;
      max-width: 1200px;
      margin: 20% auto 50px;
      background-image: url(https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=3469411649,3611337938&fm=26&gp=0.jpg);
      background-size: cover;
      .bigbox{
        position: absolute;
        left: 48%;
        top: -20%;
        width: 48%;
        height: 100%;
        z-index: 30;
        box-shadow:  0 0 10px #999;
        border-radius: 8px;
        background-color: #ffffff;
        box-sizing: border-box;
        padding: 11vw 30px 30px;
        font-size: 14px;
        letter-spacing: 1px;
        line-height: 24px;
        text-indent: 28px;
        color: #1CAD8E;
        .logo{
          position: absolute;
          left: 10%;
          top: -20%;
          z-index: 40;
          height: 50%;
          width: 50%;
          box-shadow:  0 0 10px #999;
          border-radius: 8px;
          // background-color: #1CAD8E;
          background-color: #ffffff;
          box-sizing: border-box;
          color: #ffffff;
          text-indent: 0;
          padding: 2vw 1vw;
          display: -webkit-box;
          -webkit-box-pack: center;
          box-pack: center;
          -webkit-box-align: center;
          box-align: center;
          p{
            text-align: center;
          }
          span{
            font-size: 70px;
          }
          img{
            width: auto;
            max-height: 150px;
          }
        }
      }
    }
    .culture{
      .content{
        line-height: 30px;
        letter-spacing: 1px;
        max-width: 1200px;
        margin: 0 auto;
        img{
          max-width: 100%;
          display: inline-block;
          margin:  10px auto;
        }
      }
    }
    .idea{
      ul{
        display: flex;
        margin-top: 100px;
        li{
          flex:  0 0 20%;
          text-align: center;
          margin-bottom: 50px;
          img{
            width: 100px;
          }
          p{
            margin-top: 30px;
          }
        }
      }
    }
    @media only screen and (max-width: 1220px){
        .intro{
            .bigbox{
              height: auto;
              width: 70%;
              left:26%;
              .logo{
                left: 30px;
                width: calc(100% - 60px);
              }
            }
        }
    }
    @media only screen and (max-width: 940px){
      .intro{
        box-shadow: none;
        height: auto;
        width: 100%;
        background-image: none;
        .bigbox{
          height: auto;
          width: 100%;
          position: static;
          padding-top: 100px;
          .logo{
            left: 30px;
            width: calc(100% - 60px);
            height: 154px;
            top: -70px;
          }
        }
      }
    }
    @media only screen and (max-width: 706px){
      .intro{
        margin-top: 100px;
        .logo{
          height: 154px;
        }
      }
      .idea{
        ul{
          margin-top: 30px;
          flex-wrap: wrap;
          li{
            flex:  0 0 50%;
            text-align: center;
            margin-bottom: 50px;
            img{
              width: 100px;
            }
            p{
              margin-top: 30px;
            }
          }
        }
      }
    }
    @media only screen and (max-width: 420px){
      .intro{
        margin-top: 100px;
      }
    }
    
</style>
